/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import CursoConstanciaForm from './CursoConstanciaForm';
import * as validations from '../../validations/validations';
import * as cursoconstanciaActions from '../../actions/cursoconstanciaActions';
import * as cursoActions from '../../actions/cursoActions';

import {  useParams } from "react-router-dom";
import {  useLocation, useNavigate  } from "react-router-dom";
import withRouter from '../common/withRouter';
import * as userActions from '../../actions/userActions';

import * as paginaActions from '../../actions/paginaActions';
import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import { Segment} from 'semantic-ui-react';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import moment from 'moment';
import {getMargenes, usuarioActual} from '../../util/';
import $ from 'jquery';
import dayjs from 'dayjs';


class ManageCursoConstanciaForm extends React.Component {

    constructor(props, context){
		super(props, context);
		this.state={
            errors:{},
            permisos:{},
            imgFondo:{},
            imgFirma:{},
            usuario:{},
			cursoconstancia:{
                fecha: new moment().format('DD/MM/YYYY')
            }
        }
    };
		
    
    componentDidMount(){
        
       
        /*
        let pageInfo={ 
            page:'cursoconstancia', 
            idioma:this.props.idioma     
        };
        */
        //this.props.showSidebarIzquierdaActions.sidebarIzquierda(true);  
        /*
        this.props.paginaActions.getInfo(pageInfo, this.props.user).then( pageInfoResponse=>{ 
           this.setState({"permisos":pageInfoResponse.permisos, 
                         "strings":Object.assign({}, pageInfoResponse.strings)}); 
       }) 
        .catch(error=>{ 
          toastr.error(error); 
        }); 
        */
        
        usuarioActual(this, "cursoconstancia",true).then( (usuario)=>{
        
            
            let id=this.props.id;
            
            this.props.cursoActions.getCursoCombo(usuario).then(()=>{}) 
                .catch(error=>{ 
                  toastr.error(error); 
                }); 

            if(id && id>0 ){

               this.props.cursoconstanciaActions.getCursoConstancia(id, usuario).then( cursoconstancia=>{

                   if(cursoconstancia.fecha!=null){
                            cursoconstancia.fecha= new moment(cursoconstancia.fecha).format('DD/MM/YYYY');    
                        }else{
                            cursoconstancia.fecha= new moment().format('DD/MM/YYYY'); 
                        }

                   this.setState({"cursoconstancia":cursoconstancia});
               })
                .catch(error=>{
                  toastr.error(error);
                }); 
            }
        })
        .catch(error=>{
          toastr.error(error);
        }); 
		
    }
    

    handleChange=(event, data)=> {

        let cursoconstancia = this.state.cursoconstancia;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		cursoconstancia[field[0]]= value;
		else{
             if(!cursoconstancia[field[0]]){
                    cursoconstancia[field[0]]={}
                }
			cursoconstancia[field[0]][field[1]]= value;
		}
        
		
        this.setState({"cursoconstancia": cursoconstancia});
    }
    
    
    
     handleFile=(event, data)=> {
        let tamano;
        let imgFondo = this.state.imgFondo;
        let field= data.name;		
        let value;
        
        let file = event.target.files[0];
        if (!file){
            imgFondo.fileReg = '';
            imgFondo.imagePreviewUrl='';

            this.setState({"fileReg": ''});
            this.setState({"imgFondo": imgFondo});
            return;
        }


        if(event.target.files[0].size<=(1024*1024)*2){
            imgFondo['fileReg'] = event.target.files[0];
            imgFondo['imagePreviewUrl'] = URL.createObjectURL(event.target.files[0]);
            this.setState({"fileReg": '1'});
            this.setState({"imgFondo": imgFondo});
            
            //console.log(imgFondo);
            
        }else{
            tamano= Number(event.target.files[0].size)/Number(1048576);
            imgFondo.fileReg = '';
            imgFondo.imagePreviewUrl='';
            this.setState({"fileReg": ''});
            this.setState({"imgFondo": imgFondo});

            toastr.error("El archivo que intenta anexar mide "+tamano.toFixed(2)+"Mb. No se permiten imagnees mayores a 2 Mb!!!");
            return;
        } 
         
     }
     
     HandleFileFirma=(event, data)=> {
        let tamano;
        let imgFirma = this.state.imgFirma;
        let field= data.name;		
        let value;
        
        let file = event.target.files[0];
        if (!file){
            imgFirma.fileReg = '';
            imgFirma.imagePreviewUrl='';

            this.setState({"fileReg": ''});
            this.setState({"imgFirma": imgFirma});
            return;
        }


        if(event.target.files[0].size<=(1024*1024)){
            imgFirma['fileReg'] = event.target.files[0];
            imgFirma['imagePreviewUrl'] = URL.createObjectURL(event.target.files[0]);
            this.setState({"fileReg": '1'});
            this.setState({"imgFirma": imgFirma});
            
        }else{
            tamano= Number(event.target.files[0].size)/Number(1048576);
            imgFirma.fileReg = '';
            imgFirma.imagePreviewUrl='';
            this.setState({"fileReg": ''});
            this.setState({"imgFirma": imgFirma});

            toastr.error("El archivo que intenta anexar mide "+tamano.toFixed(2)+"Mb. No se permiten imagnees mayores a 1 Mb!!!");
            return;
        } 
         
     }
    
    fechas=(fechasArreglo, fechasCadena)=>{
        let cursoconstancia = this.state.cursoconstancia;
        cursoconstancia.fecha = fechasCadena;
        cursoconstancia.fechadayJS = fechasArreglo;
             //new moment(fechasCadena).format("MM-DD-YYYY");
             //this.state.nuevo.fechaInicioExamen[0].format("DD-MM-YYYY");
        this.setState({cursoconstancia:cursoconstancia});
    }
    
    
    FormIsValid(){
        let formIsValid=true;
        let falla="";
        let errors={};
            
        let cursoconstancia=this.state.cursoconstancia;
              
        if(!validations.requerido(cursoconstancia.cursoId)){
            errors.cursoId=true;
            formIsValid=false;
        }
       

       
        if(!validations.requerido(cursoconstancia.fecha)){
            errors.fecha=true;
            formIsValid=false;
        }
       
       /*
        if(!validations.requerido(cursoconstancia.nombreFirma)){
            errors.nombreFirma=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(cursoconstancia.puestoFirma)){
            errors.puestoFirma=true;
            formIsValid=false;
        }
       
        if(!validations.requerido(cursoconstancia.empresaFirma)){
            errors.empresaFirma=true;
            formIsValid=false;
        }
       */
       
        this.setState({
            "errors":errors
        });
        
        if(!formIsValid){
			toastr.error("Debes capturar la información requerida.");
        }
    
        return formIsValid;
    }



    onSave=(event)=>{
        event.preventDefault();
        if(!this.FormIsValid()){
            return ;
        }
        
        let newState=Object.assign({}, this.state.cursoconstancia);
        /*
        if(moment.isMoment(newState.fecha)){
            newState.fecha = new moment(newState.fecha).format('YYYY-MM-DD');
        }else{
            newState.fecha = moment(newState.fecha, 'DD/MM/YYYY'); 
            newState.fecha = new moment(newState.fecha).format('YYYY-MM-DD');
            
        }
        */
        
        newState.fecha = dayjs(this.state.cursoconstancia.fechadayJS).format('YYYY-MM-DD hh:mm:ss');
        
        newState.templateForm=1;
        
        
        this.props.cursoconstanciaActions.save(newState, this.props.user).then((cursoConstanciaGuardado) => {
            toastr.success("Registro guardado!!!.");
            
            
             var questionPic = this.state.imgFondo.fileReg;


                    if(questionPic instanceof File){

                        var form_data = new FormData();
                        form_data.append('file', questionPic);
                        form_data.append('cursoConstanciaId', cursoConstanciaGuardado.id);

                        this.props.cursoconstanciaActions.saveImagenFondoImage(form_data, this.props.user).then((imagen) => {

                            toastr.success("Imagen guardada correctamente!!!.");
                            
                        }).catch(error=>{
                          toastr.error(error.responseJSON.message);
                        });

                    }

            
            var questionPic = this.state.imgFirma.fileReg;
            
            if(questionPic instanceof File){

                        var form_data = new FormData();
                        form_data.append('file', questionPic);
                        form_data.append('cursoConstanciaId', cursoConstanciaGuardado.id);

                        this.props.cursoconstanciaActions.saveImagenFirmaImage(form_data, this.props.user).then((imagen) => {

                            toastr.success("Imagen de firma guardada correctamente!!!.");
                            
                        }).catch(error=>{
                          toastr.error(error.responseJSON.message);
                        });

                    }
            
            
            //this.props.history.push('/cursoconstancias');
            this.props.navigate(-1);
            
            
            
            
            
        });
        
    }

       
    render() {	
          
   let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda);
		 		return (
              <Segment  style={margenes}>
                <CursoConstanciaForm 
                    strings={this.props.strings}
                    id={this.props.id}
                    onChange={this.handleChange}
                    errors={this.state.errors}
                    datos={this.state.cursoconstancia}
                    onSave={this.onSave}      
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    color={this.props.color}
                    form={this.props.form}
                    permisos={this.state.permisos}
                    fechas={this.fechas}
                    cursoCombo={genericFormattedForDropdown(this.props.cursoCombo)}
                    onHandleFile={this.handleFile}
                    onHandleFileFirma={this.HandleFileFirma}
                />

            </Segment> 
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps, match ){
    
    return {        
        ajaxCallInProgress:state.ajaxCallInProgress,
        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda, 
        color:state.color,
        user:state.user, 
        idioma:state.idioma,
        form:state.form,
        cursoCombo:state.cursoCombo,
        strings:state.strings
    }

}

function mapDispatchToProps(dispatch){

	return {   
            userActions: bindActionCreators(userActions, dispatch),
            showSidebarIzquierdaActions: bindActionCreators(showSidebarIzquierdaActions, dispatch),
            paginaActions: bindActionCreators(paginaActions, dispatch),
            cursoconstanciaActions: bindActionCreators(cursoconstanciaActions, dispatch),
            cursoActions: bindActionCreators(cursoActions, dispatch)
	};
}



export default connect (mapStateToProps, mapDispatchToProps)(withRouter(ManageCursoConstanciaForm));